import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  container: {
    margin: 10,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  containerCode: {
    width: '100%',
    alignItems: 'flex-end',
  },
  codeText: {
    fontSize: 12,
  },
  containerTitleDescription: {
    marginTop: '18%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerTitle: {
    padding: '10px 0px',
  },
  titleText: {
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 700,
  },
  containerDescription: {
    paddingHorizontal: 10,
    lineHeight: 1.4,
  },
  descriptionText: {
    textAlign: 'justify',
  },
  containerCid: {
    paddingHorizontal: 10,
    marginTop: 20,
    fontSize: 14,
  },
  cidText: {},
});
